<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400" >
       <h1>ข้อตกลงความเป็นส่วนตัว</h1>
       <div class="textBox" style="white-space: pre-wrap">{{text}}</div>
       
      </div>
    </div>
 
  </div>
</template>

<script>
import importedImg1 from "@/page/vcwealthloan/components/img/Rectangle1.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      text:`ตามบทบัญญัติของกฎหมายของรัฐบาลกลางว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลในครอบครองส่วนตัว (LFPDPPP) และข้อบังคับ แนวทางของแถลงการณ์ความเป็นส่วนตัวและบทบัญญัติอื่น ๆ ที่เกี่ยวข้อง (รวมเรียกว่า "กฎหมาย") แถลงการณ์ความเป็นส่วนตัวนี้จึงออกให้ ตามเงื่อนไขต่อไปนี้:

รับผิดชอบข้อมูลส่วนบุคคล เพื่อวัตถุประสงค์ของคำชี้แจงความเป็นส่วนตัวนี้ เรามีหน้าที่รับผิดชอบตามกฎหมายในการรวบรวม การเปิดเผย การจัดเก็บ และการใช้งาน รวมถึงการเข้าถึง การปฏิบัติ การใช้ การแสวงหาผลประโยชน์ การถ่ายโอน หรือการกำจัดข้อมูลส่วนบุคคลของคุณที่เรารวบรวมและโดยทั่วไป ของข้อมูลส่วนบุคคลทั้งหมดที่เรารวบรวมจากลูกค้าและผู้ใช้ของเรา

สิทธิ์
เพื่อประเมินคุณสมบัติของคุณและช่วยคุณจำกัดการตัดสินใจว่าคุณมีสิทธิ์สำหรับผลิตภัณฑ์ทางการเงินของเราหรือไม่ ข้อมูลทั้งหมดจะถูกรวบรวมและนำเสนอโดยใช้เทคโนโลยีความปลอดภัยล่าสุด (https) เราต้องได้รับอนุญาตบางอย่างในการเข้าถึงโทรศัพท์มือถือของคุณและคุณ สามารถติดต่อศูนย์บริการลูกค้าของเราได้ตลอดเวลาเพื่อขอลบข้อมูลส่วนบุคคลของคุณ เราจะไม่เปิดเผยข้อมูลของคุณกับบุคคลที่สามที่ไม่เกี่ยวข้องกับวัตถุประสงค์ของการสมัคร เว้นแต่จะได้รับคำสั่งจากรัฐบาล ตามกฎหมายของรัฐและ Google เราจะเคารพและรักษาความเป็นส่วนตัวของข้อมูลที่คุณแบ่งปันกับเราในระหว่างการประเมินการสมัครขอสินเชื่อของคุณ
การติดต่อในกรณีฉุกเฉิน

เราจะรวบรวมผู้ติดต่อในกรณีฉุกเฉินของคุณเพียง 2 หรือ 5 รายเพื่อการยืนยันตัวตน การจัดการความเสี่ยง และการควบคุมการต่อต้านการฉ้อโกง (คุณสามารถเลือกข้อมูลการติดต่อที่คุณต้องการกรอกจากสมุดที่อยู่ของคุณ ซึ่งจะบันทึกเฉพาะผู้ติดต่อที่คุณเลือกไว้ในสมุดที่อยู่ของคุณ ไม่ใช่ผู้ติดต่อทั้งหมดของคุณ) เราจะไม่เปิดเผยข้อมูลของคุณกับบุคคลที่สามโดยไม่ได้รับอนุญาตจากคุณ ข้อมูลจะถูกเข้ารหัสและอัปโหลดและจัดเก็บไว้ในเซิร์ฟเวอร์ของเราผ่านการเชื่อมต่อที่ปลอดภัย (https) และเราจะรวบรวมข้อมูลนี้เมื่อได้รับความยินยอมจากคุณเท่านั้น ข้อมูลของคุณจะได้รับการคุ้มครองโดยเราอย่างเคร่งครัด

ที่ตั้ง
เรารวบรวมข้อมูลตำแหน่งจากอุปกรณ์ของคุณเพื่อลดความเสี่ยงที่เกี่ยวข้องกับบัญชีของคุณและเพิ่มความปลอดภัยของข้อมูล ธุรกรรมทั้งหมดได้รับการคุ้มครองโดยการเข้ารหัส SSL 128 บิต ข้อมูลจะถูกอัพโหลดผ่านการเชื่อมต่อที่ปลอดภัยและจัดเก็บไว้ในเซิร์ฟเวอร์ของเรา

กล้อง
การเข้าถึงกล้องช่วยให้เราสามารถสแกนเอกสาร KYC ที่จำเป็น เพื่อให้เราสามารถเติมฟิลด์ที่เกี่ยวข้องได้โดยอัตโนมัติ นอกจากนี้ยังจะใช้เพื่อทำให้กระบวนการ KYC วิดีโอของคุณเสร็จสมบูรณ์ ซึ่งใช้เพื่อยืนยันว่าคุณกำลังสมัครด้วยตนเอง เพื่อป้องกันไม่ให้ข้อมูลของคุณถูกขโมยหรือส่งผลให้เกิดการฉ้อโกง
ข้อมูลที่ติดตั้งในแอปพลิเคชัน
เราใช้คุกกี้ คุกกี้เป็นเครื่องมือที่เว็บเซิร์ฟเวอร์ใช้เพื่อจัดเก็บและเรียกค้นข้อมูลที่จัดเก็บไว้ในเบราว์เซอร์ที่ผู้ใช้หรือผู้เยี่ยมชมเว็บไซต์ใช้ ช่วยให้สามารถบันทึกการตั้งค่าส่วนบุคคลเพื่อมอบประสบการณ์การท่องเว็บที่ดียิ่งขึ้น

คุกกี้มีวันหมดอายุซึ่งอาจมีตั้งแต่ระยะเวลาของเซสชันหรือการเข้าชมเว็บไซต์จนถึงวันที่กำหนด หลังจากนั้นจะไม่มีการใช้งานอีกต่อไป คุกกี้ที่ใช้จะเชื่อมโยงกับผู้ใช้ที่ไม่ระบุชื่อและอุปกรณ์คอมพิวเตอร์เท่านั้น โดยไม่ได้ให้ข้อมูลอ้างอิงที่อนุญาตให้อนุมานชื่อและนามสกุลของผู้ใช้ได้ ไม่อ่านข้อมูลจากฮาร์ดไดรฟ์และไม่มีไวรัสในข้อความ

ผู้ใช้สามารถกำหนดค่าเบราว์เซอร์ให้ยอมรับหรือปฏิเสธคุกกี้ทั้งหมดโดยอัตโนมัติหรือรับการแจ้งเตือนบนหน้าจอเกี่ยวกับการยอมรับคุกกี้แต่ละรายการและตัดสินใจว่าจะติดตั้งคุกกี้บนฮาร์ดไดรฟ์หรือไม่เราขอแนะนำให้คุณศึกษาในส่วนนี้ ใช้หน้าช่วยเหลือของเบราว์เซอร์ของคุณเพื่อเรียนรู้วิธีเปลี่ยนการตั้งค่าเพื่อยอมรับหรือปฏิเสธคุกกี้ แม้ว่าคุณจะกำหนดค่าเบราว์เซอร์ของคุณให้ปฏิเสธคุกกี้ทั้งหมดหรือปฏิเสธคุกกี้อย่างชัดเจน คุณจะสามารถเรียกดูไซต์ต่อไปได้ โดยมีข้อเสียเปรียบเพียงอย่างเดียวคือคุณจะไม่สามารถเพลิดเพลินกับฟังก์ชันของไซต์ที่ต้องมีการติดตั้งคุกกี้ได้ ไม่ว่าในกรณีใด คุณสามารถลบคุกกี้ที่ติดตั้งบนฮาร์ดไดรฟ์ของคุณได้ตลอดเวลาโดยปฏิบัติตามขั้นตอนที่ระบุไว้ในส่วนความช่วยเหลือของเบราว์เซอร์ของคุณ

เรายืนยันว่าเราไม่ได้เก็บรวบรวมข้อมูลส่วนบุคคลผ่านวิธีการเหล่านี้ ดังนั้นข้อมูลเหล่านี้จึงไม่อยู่ภายใต้การประมวลผลหรือถ่ายโอน
สิ่งสำคัญคือเราแจ้งให้คุณทราบว่าเราจะไม่ใช้ข้อมูลที่เก็บรวบรวมโดยวิธีการเหล่านี้เพื่อวัตถุประสงค์ส่วนบุคคลหรือวัตถุประสงค์อื่น ๆ เราไม่สามารถเพิกถอนการอนุญาตเหล่านี้ได้เนื่องจากจะต้องได้รับการแก้ไขจากโทรศัพท์มือถือที่ได้รับอนุญาต ดังนั้นคุณจึงสามารถเพิกถอนการอนุญาตเหล่านี้ได้ตลอดเวลาโดยเข้าไปที่การตั้งค่าโทรศัพท์มือถือของคุณ

สิ่งสำคัญคือคุณต้องรู้ว่าคุณสามารถติดต่อเราได้ตลอดเวลาโดยใช้ข้อมูลติดต่อที่เราให้ไว้ในเว็บไซต์ของเรา และเรายินดีที่จะแนะนำคุณเกี่ยวกับขั้นตอนการเพิกถอนความยินยอมก่อนหน้านี้จากอุปกรณ์ของคุณ

เราจะได้รับแจ้งการตัดสินใจภายในระยะเวลาสูงสุดยี่สิบ (20) วันทำการนับจากได้รับคำขอที่เกี่ยวข้อง หากคำขอของคุณได้รับการยอมรับ จะมีผลภายในสิบห้าวันทำการนับจากวันที่ผู้ควบคุมส่งคำตอบ

หากข้อมูลที่ให้ไว้ในคำขอของคุณไม่ถูกต้องหรือไม่เพียงพอ หรือหากไม่มีเอกสารที่จำเป็นในการพิสูจน์ตัวตนของคุณหรือการรับรองทางกฎหมายที่เกี่ยวข้อง หรือเอกสารอื่นใดที่จำเป็นต่อการใช้สิทธิ์ของคุณ เราจะขอให้คุณแก้ไขข้อบกพร่อง ภายในห้าวันทำการนับจากวันที่ได้รับคำขอของคุณเพื่อดำเนินการ ในกรณีนี้ คุณจะมีเวลาสิบวันทำการนับจากวันถัดจากวันที่ได้รับคำขอแก้ไขในการตอบกลับ หากคุณไม่ตอบกลับภายในระยะเวลานี้จะถือว่าไม่มีการส่งคำขอที่เกี่ยวข้อง

หากคุณมีเงินกู้ปัจจุบันกับเรา (ครบกำหนดหรือกำลังจะหมดอายุ) เราจะไม่สามารถแก้ไขโปรไฟล์ของคุณได้ ในการดำเนินการนี้ คุณจะต้องชำระคืนเงินกู้ของคุณก่อน และเมื่อชำระคืนแล้ว ให้ทำตามขั้นตอนที่อธิบายไว้ข้างต้น โปรดจำไว้ว่าหากคุณไม่เห็นด้วยหรือไม่ปฏิบัติตามกฎของเรา คุณสามารถไปที่ National Institute of Transparency, Access to Information and Protection of Personal Data (INAI) เพื่อเริ่มขั้นตอนการคุ้มครองสิทธิ์

ในฐานะเจ้าของ คุณมีหน้าที่รับผิดชอบในการอัปเดตข้อมูลส่วนบุคคลของคุณที่อยู่ในความครอบครองของเรา ดังนั้นในทุกกรณี คุณรับประกันและรับผิดชอบต่อความถูกต้อง ความถูกต้อง ความถูกต้อง และความถูกต้องของข้อมูลส่วนบุคคลที่ให้ไว้ และดำเนินการปรับปรุงข้อมูลให้ทันสมัยอยู่เสมอ และเพื่อสื่อสารการเปลี่ยนแปลงใด ๆ ไปยังผู้ควบคุมข้อมูล

การเพิกถอนความยินยอม

คุณสามารถเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลของคุณได้ตลอดเวลา โดยมีเงื่อนไขว่าการเพิกถอนดังกล่าวถูกต้องตามกฎหมายและไม่ได้หมายความถึงความเป็นไปไม่ได้ในการปฏิบัติตามภาระผูกพันที่ได้รับจากความสัมพันธ์ตามสัญญาในปัจจุบันระหว่างเรากับคุณ หรือโดยอาศัยอำนาจตามกฎหมาย อาณัติ. หรือตุลาการ.

การเปลี่ยนแปลงคำชี้แจงสิทธิส่วนบุคคล การอัปเดต การแก้ไข หรือการเปลี่ยนแปลงคำชี้แจงความเป็นส่วนตัวนี้ตามกฎหมายใหม่และ/หรือการเปลี่ยนแปลงนโยบายภายในของเราจะถูกโพสต์บนเว็บไซต์

อย่างไรก็ตาม เมื่อมีการเปลี่ยนแปลงเนื้อหาในคำชี้แจงความเป็นส่วนตัวนี้ เช่น การเปลี่ยนแปลงวัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคล เราจะแจ้งให้คุณทราบ และขอความยินยอมจากคุณอีกครั้งเพื่อดำเนินการประมวลผลข้อมูลของคุณต่อไป ส่วนบุคคล

นโยบายความปลอดภัย

เราปกป้องข้อมูลส่วนบุคคลของคุณโดยใช้เทคโนโลยีการเข้ารหัสมาตรฐานอุตสาหกรรมเพื่อให้แน่ใจว่าข้อมูลที่ส่งจากเว็บไซต์มาถึงเซิร์ฟเวอร์ของเราอย่างปลอดภัย เราใช้มาตรการรักษาความปลอดภัยเพื่อปกป้องข้อมูลส่วนบุคคลของคุณเมื่อเราจัดเก็บและประมวลผลข้อมูลของคุณ

เรามีขั้นตอนที่กำหนดว่าใครสามารถเข้าถึงข้อมูลของคุณได้และภายใต้เงื่อนไขใด และการปกป้องความเป็นส่วนตัวของคุณถือเป็นสิ่งสำคัญสูงสุดของเราเสมอ นอกจากนี้เรายังมีมาตรการรักษาความปลอดภัยทางกายภาพเพื่อป้องกันการเข้าถึงระบบและสิ่งอำนวยความสะดวกของเราโดยไม่ได้รับอนุญาต
ความยินยอมของคุณ

การอ่านและยอมรับคำชี้แจงสิทธิ์ส่วนบุคคลนี้ทุกครั้งที่คุณเข้าถึงข้อมูลผู้ใช้ของคุณไม่ว่าด้วยวิธีใดก็ตาม แสดงว่าคุณระบุอย่างชัดแจ้งว่า

1. เราได้รับแจ้งถึงคำชี้แจงความเป็นส่วนตัวนี้

2. คุณได้อ่านและเข้าใจข้อกำหนดและขอบเขตของคำชี้แจงความเป็นส่วนตัวนี้โดยสมบูรณ์แล้ว และยินยอมอย่างชัดแจ้งต่อการประมวลผลข้อมูลส่วนบุคคลของคุณตามข้อกำหนดของคำชี้แจงความเป็นส่วนตัวนี้

การรักษาความปลอดภัยของข้อมูลส่วนบุคคล เราให้ความสำคัญกับข้อมูลส่วนบุคคลทั้งหมดที่เรารวบรวม ใช้ เก็บรักษา และจัดเก็บ เราได้นำมาตรการรักษาความปลอดภัยที่เหมาะสมมาใช้ทั้งทางเทคนิคและทางกายภาพ เพื่อปกป้องข้อมูลของคุณจากการเข้าถึงหรือสูญหายโดยไม่ได้รับอนุญาต การใช้ในทางที่ผิดหรือการเปลี่ยนแปลงโดยบุคคลที่สาม แม้ว่าเราจะพยายามเข้ารหัสข้อมูลที่รวบรวมบนแพลตฟอร์มและอัปโหลดไปยังเซิร์ฟเวอร์ แต่เราไม่สามารถรับประกันความปลอดภัยที่แท้จริงของข้อมูลดังกล่าวในระหว่างการส่งหรือจัดเก็บข้อมูลได้ เราจะใช้มาตรการทางเทคนิคและองค์กรที่เหมาะสมเพื่อปกป้องข้อมูลผู้ใช้ มาตรการที่เราใช้ได้รับการออกแบบเพื่อให้มีระดับความปลอดภัยตามสัดส่วนความเสี่ยงที่เกี่ยวข้องกับการประมวลผลข้อมูลส่วนบุคคลของผู้ใช้ และเราปรับปรุงอย่างต่อเนื่อง มาตรการของเราแตกต่างกันไป แต่โดยทั่วไปจะรวมถึงการควบคุมเพื่อจำกัดการเข้าถึงบริการหรือระบบที่มีข้อมูลส่วนบุคคล การใช้นามแฝง ไฟร์วอลล์เพื่อปกป้องฐานข้อมูล รหัสผ่าน และมาตรการทางเทคนิคอื่น ๆ นอกจากนี้ แม้ว่าเรามุ่งมั่นที่จะรับรองความสมบูรณ์และความปลอดภัยของเครือข่ายและระบบของเรา แต่เราไม่สามารถรับประกันได้ว่ามาตรการรักษาความปลอดภัยของเราจะป้องกัน "แฮกเกอร์" บุคคลที่สามจากการเข้าถึงข้อมูลนี้อย่างผิดกฎหมายได้อย่างสมบูรณ์ ในกรณีที่ไม่น่าเป็นไปได้ที่การโจรกรรมข้อมูลเกิดขึ้นเนื่องจากการแฮ็กโดยไม่ได้รับอนุญาต การโจมตีของไวรัส หรือปัญหาทางเทคนิค เราจะไม่รับผิดชอบ`,
      altText: "图片",
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
}
.imgBox1
{
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}
.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 2900px;
  background-color: #FFFFFF;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}
.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem2 {
  max-width: 100%;
}
.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
h1{
  /* margin-top: 50px; */
 margin-left: 490px;
 color: #333333;
 font-size: 40px;
/* border-bottom: 5px solid #04358A; */
display: inline-block
}
.textBox{
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}
.imgBox2{
  transform: scale(90%,90%);
  margin: -390px auto 0;
}
</style>